/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import logo from "../../assets/image/outcess-logo.png"
import { useNavigate, useParams } from 'react-router-dom';
import Copyright from '../../components/ModalComponents/Copyright';
import img from '../../assets/image/outcess-icon-haf.png';
import { useAppDispatch, useAppSelector } from '../../useStore';
import { Spinners } from '../../components/TableOptions';
import { eligibilityCheck, reset } from '../../features/Test/testSlice';
import swal from "sweetalert";

const TestLogin = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const [inputs, setInputs] = useState({
		applicationId: "",
		email: "",
	})



	const {
		eligibilityCheckisError,
		eligibilityCheckmessage,
		eligibilityCheckisLoading,
		eligibilityCheckisSuccess } = useAppSelector((state: { test: any; }) => state.test)

	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				applicationId: id
			});
		});
	}, [setInputs, id]);

	const handleeEligibilityCheck = (e: any) => {
		e.preventDefault();
		// @ts-ignore  
		dispatch(eligibilityCheck(inputs));
		// navigate('/testquestionpreviewdetails', { state: { data: id } });
	}


	useEffect(() => {
		if (eligibilityCheckisError) {
			swal({
				title: "error",
				text: eligibilityCheckmessage,
				icon: "error"
			})
			dispatch(reset())
		} else if (eligibilityCheckisSuccess) {
			swal({
				title: "success",
				text: eligibilityCheckmessage,
				icon: "success"
			})
			navigate('/testquestionpreviewdetails', { state: { data: id } });
			dispatch(reset())
		}
	}, [dispatch, eligibilityCheckisError, eligibilityCheckisSuccess, eligibilityCheckmessage, id, navigate])


	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	return (
		<div>
			<div className="login-form-container">
				<div id="login-form" >
					<div className="logo-form  ">
						<img src={logo} alt='logo' />
					</div>
					<p className="form-title"> We are glad to see you, Please enter same email you used for job Application</p>
					<div className="login-divider  ">
						<h2>
							<span>Enter Email</span>
						</h2>
					</div>

					<form>
						<input
							placeholder="Username"
							type="text"
							value={inputs?.email}
							onChange={(e) => handleOnChange("email", e.target.value)}
						/>
						<section className="links">
							<button className="button" onClick={handleeEligibilityCheck}>
								<span>{eligibilityCheckisLoading ? <Spinners size={"sm"} /> : 'LOGIN'}</span>
							</button>
						</section>
					</form>
				</div>

			</div >
			<div className='Copyright-footer'>
				<img src={img} alt="logo" className='Copyright-img' />	<Copyright />
			</div>
		</div>
	)
}

export default TestLogin
